<style>
    .page-item {
        cursor: pointer;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Produk</h1>
            <div class="section-header-breadcumb button">
                <a :href="siteUrl+'Produk/exportExcel/'+filter" target="_blank" class="btn btn-outline-info" style="margin-right:5px;"><i class="fa fa-file-excel-o"></i> Export to Excel</a>
                <a href="javascript:" @click.prevent="goTo('/produk/daftar-produk/buat-produk')" class="btn btn-icon icon-left btn-primary"><i class="far fa-edit"></i> Buat Produk Baru</a>
            </div>
          </div>
        <div class="section-body">
           <div class="row">
                <div class="col-12">
                    <div class="card">
                    <div class="card-header">
                        <h4>Daftar Produk</h4>
                        <div class="card-header-form">
                            <div class="input-group">
                            <input type="text" v-model="filter" @keyup.enter="setFilter()" class="form-control" placeholder="Search">
                            <div class="input-group-btn">
                                <button @click="setFilter()" class="btn btn-primary"><i class="fas fa-search"></i></button>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive">
                        <table class="table table-striped table-hover">
                            <tr>
                                <th>#</th>
                                <th></th>
                                <th>Kode Produk</th>
                                <th>Nama Produk</th>
                                <th>Qty</th>
                                <th>Unit</th>
                                <th>Harga Beli/Produksi</th>
                                <th>Harga Beli/Produksi Rata2</th>
                                <th>Harga Jual Rata-Rata</th>
                            </tr>
                            <tbody>
                                <tr style="cursor:pointer;" v-for="list in produkList" v-bind:key="list.main.id_produk" @click="goDetail(list.main.id_produk)">
                                    <td>{{ list.no }}</td>
                                    <td></td>
                                    <td>{{ list.main.kode_produk }}
                                        <table style="min-width:1px !important" v-if="list.alias != null">
                                            <tr style="background-color:inherit" v-for="alias in list.alias" v-bind:key="alias.id_alias">
                                                <td style="color: #acb5f6;">
                                                {{ alias.kode_alias }}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td><i v-if="list.main.is_produksi == '1'" class="fas fa-flask" style="color:#8B008B"></i>  &nbsp; {{ list.main.nama_produk }}
                                        <table style="min-width:1px !important" v-if="list.alias != null">
                                            <tr style="background-color:inherit" v-for="alias in list.alias" v-bind:key="alias.id_alias">
                                                <td style="color: #acb5f6;">
                                                {{ alias.nama_alias }}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td>{{ list.main.qty_total }} <span v-if="list.dipesan != 0">({{ list.dipesan }})</span> </td>
                                    <td>{{ list.main.nama_satuan }}</td>
                                    <td>{{ 'Rp. '+ $parent.currencyFormat(list.main.harga_beli) }}</td>
                                    <td>{{ 'Rp. '+ $parent.currencyFormat(list.harga_beli) }}</td>
                                    <td>{{ 'Rp. '+ $parent.currencyFormat(list.harga_jual) }}</td>
                                </tr>
                            </tbody>

                        </table>
                        </div>
                    </div>
                    <div class="card-footer text-right">
                        <nav class="d-inline-block">
                        <ul class="pagination mb-0">
                            <li class="page-item" :class="{ disabled : firstDisabled }">
                                <a class="page-link" v-if="firstDisabled == true" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                                <a class="page-link" v-else @click="tableTo(page-1)" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                            </li>
                            <li v-for="pages in pagination" v-bind:key="pages" class="page-item" :class="{ active: pages == page}">
                                <span class="page-link" @click="tableTo(pages)">{{ pages }}</span>
                            </li>
                            <li class="page-item" :class="{ disabled : lastDisabled }">
                                <a class="page-link" v-if="lastDisabled == true"><i class="fas fa-chevron-right"></i></a>
                                <a class="page-link" v-else @click="tableTo(page+1)"><i class="fas fa-chevron-right"></i></a>
                            </li>
                        </ul>
                        </nav>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<script>
export default {
    data() {
        return {
            produkList : [],
            perPage: 10,
            page: 1,
            search: '',
            maxPagination: 5,
            first: 1,
            last: '',
            totalRow: '',
            pagination: [],
            filter : '',
            firstDisabled : true,
            lastDisabled : true,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = !this.$root.is_loading;
            this.$http.get("Produk/getBahanList?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get produk')
                }
                else {
                    this.produkList = result.data.detail.data;
                    this.totalRow = result.data.detail.totalRow;
                    this.last = Math.ceil(this.totalRow / this.perPage)
                    this.pagination = this.getPaging();
                    this.$nextTick(function(){
                        this.navDisabled();
                    })

                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        getPaging: function() {
            var i;
            var paging = []
            if(this.page > this.first+2){
                this.first = this.page-3
            }else if(this.page == this.first && this.first != 1){
                this.first = this.page-3
                if(this.first < 1){
                    this.first = 1
                }
            }
            for(i = this.first;i < 6+this.first && i <= this.last; i++){
                paging.push(i)
            }
            return paging;
        },
        tableTo: function(page){
            this.page = page
            this.init();
        },
        goDetail: function(id_produk){
            this.$router.push({ path : 'produk-detail/'+id_produk })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        setFilter: function(){
            this.page = 1;
            this.init();
        },
        navDisabled : function() {
            console.log(this.page)
            console.log(this.first)
            console.log(this.last)
            if(this.page == this.first){
                this.firstDisabled = true
                if(this.page < this.last) {
                    this.lastDisabled = false
                }
                return
            }
            if(this.page == this.last) {
                this.lastDisabled = true
                if(this.page > this.first) {
                    this.firstDisabled = false
                }
                return
            }
            if(this.page > this.first && this.page < this.last) {
                this.lastDisabled = false
                this.firstDisabled = false
            }

        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/produk/ProdukList.vue